export default "__VITE_ASSET__BckuVNer__"